import { render, staticRenderFns } from "./SitemapLink.vue?vue&type=template&id=773b183e&"
import script from "./SitemapLink.vue?vue&type=script&lang=js&"
export * from "./SitemapLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports